import {
    RESET_PRODUCT_ROLES,
    RESET_PRODUCT_ROLES_CHANGE,
    UPDATE_PRODUCT_ROLES_CHANGE,
    UPDATE_PRODUCT_ROLES,
    FETCH_PRODUCT_ROLES,
    FETCH_PRODUCT_ROLES_START,
    FETCH_PRODUCT_ROLES_SUCCESS,
    FETCH_PRODUCT_ROLES_ERROR,
    POST_PRODUCT_ROLES,
    POST_PRODUCT_ROLES_START,
    POST_PRODUCT_ROLES_SUCCESS,
    POST_PRODUCT_ROLES_ERROR,
    UPDATE_EDIT_VALUE
  } from './constants'
  
  const resetProductRoles = () => ({ type: RESET_PRODUCT_ROLES })
  const resetProductRolesChange = () => ({ type: RESET_PRODUCT_ROLES_CHANGE })
  const updateProductRoles = (team) => ({ type: UPDATE_PRODUCT_ROLES, team })
  const updateProductRolesChange = (team, role) => ({ type: UPDATE_PRODUCT_ROLES_CHANGE, team, role })
  const fetchProductRoles = (productId) => ({ type: FETCH_PRODUCT_ROLES, productId })
  const fetchProductRolesStart = () => ({ type: FETCH_PRODUCT_ROLES_START })
  const fetchProductRolesSuccess = () => ({ type: FETCH_PRODUCT_ROLES_SUCCESS })
  const fetchProductRolesError = (error) => ({ type: FETCH_PRODUCT_ROLES_ERROR, error })
  const postProductRoles = (productId) => ({ type: POST_PRODUCT_ROLES, productId })
  const postProductRolesStart = () => ({ type: POST_PRODUCT_ROLES_START })
  const postProductRolesSuccess = () => ({ type: POST_PRODUCT_ROLES_SUCCESS })
  const postProductRolesError = (error) => ({ type: POST_PRODUCT_ROLES_ERROR, error })
  const updateEditValue = (value) => ({type: UPDATE_EDIT_VALUE, value})
  
  export {
    resetProductRoles,
    resetProductRolesChange,
    updateProductRoles,
    updateProductRolesChange,
    fetchProductRoles,
    fetchProductRolesStart,
    fetchProductRolesSuccess,
    fetchProductRolesError,
    postProductRoles,
    postProductRolesStart,
    postProductRolesSuccess,
    postProductRolesError,
    updateEditValue
  }
  